import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useDidMount } from "../../coraWebComponents/utils/hooks";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Ziadosti.scss";

// proptypes
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";

// components
import ZiadostDetail from "./ZiadostDetail";
import Grid from '../../coraWebComponents/dataGrid/DataGrid';
import Tab from "../../coraWebComponents/Tab";
import Tabs from "../../coraWebComponents/TabsWrapper";
import flags from '../../coraWebComponents/dataGrid/flags';
import * as storage from '../../coraWebComponents/utils/storage';

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as zpCDovodActions from "../../actions/ciselniky/zpCDovodActions";
import * as zpCPrioritaActions from "../../actions/ciselniky/zpCPrioritaActions";
import * as zpCStavZiadostiActions from "../../actions/ciselniky/zpCStavZiadostiActions";
import * as zpCTypPraceActions from "../../actions/ciselniky/zpCTypPraceActions";
import * as ziadostActions from "../../actions/ziadostActions";
import { useLocation, useNavigate } from "react-router";

const MojeZiadosti = (props) => {
  const { isLoading, total, listZiadosti } = props;

  const location = useLocation();
  const navigate = useNavigate();

  //name of parameter in url /mojeZiadosti?<parameterNameKodZiadostiInUrl>=230504-0845
  const parameterNameKodZiadostiInUrl = "KOD_ZIADOSTI";

  const initSort = useMemo(() => [
    { field: "D_POD", dir: "desc" }
  ], []);
  const initPage = { skip: 0, take: 5 };
  const initFilter = () => {
    try {
      const urlParams = new URLSearchParams(location.search);
      const kod = urlParams.get(parameterNameKodZiadostiInUrl);

      if (kod) {
        return {
          filters: [
            { field: parameterNameKodZiadostiInUrl, operator: "contains", value: kod },
            { field: "I_UZ", operator: "eq", value: user.Uzivatel.I_UZ }
          ],
          logic: "and"
        };
      }
    } catch { }

    return { filters: [] };
  };

  const [selected, setSelected] = useState([]);
  const filter = useRef(initFilter());
  const sort = useRef(initSort);
  const page = useRef(initPage);
  const setFilter = (newFilter) => { filter.current = newFilter };
  const setSort = (newSort) => { sort.current = newSort };
  const setPage = (newPage) => { page.current = newPage };

  const [data, setData] = useState([]);
  const [detailExpand, setDetailExpand] = useState({});

  const expandChange = useCallback((event) => {
    setDetailExpand(event.detailExpand);
  }, []);

  useEffect(() => {
    setData(listZiadosti);
  }, [listZiadosti]);


  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const kod = urlParams.get(parameterNameKodZiadostiInUrl);
    if (!kod) return;

    const { getListZiadosti } = props;
    const newFilter = {
      filters: [
        { field: parameterNameKodZiadostiInUrl, operator: "contains", value: kod },
        { field: "I_UZ", operator: "eq", value: user.Uzivatel.I_UZ }
      ],
      logic: "and"
    };

    const newSort = initSort;
    const newPage = { skip: 0, take: page.current.take };
    setFilter(newFilter);
    setSort(newSort);
    setPage(newPage);
    getListZiadosti(newFilter, newSort, newPage);

  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const kod = urlParams.get(parameterNameKodZiadostiInUrl);
    if (!kod) return;

    if (data && data.length > 0) {
      //Expand ziadost with given KOD_ZIADOSTI
      const ziadostToExpand = data.find(item => item.KOD_ZIADOSTI === kod);
      if (ziadostToExpand) {
        setDetailExpand(oldDetailExpand => {
          const updated = { ...oldDetailExpand };
          updated[ziadostToExpand.I_AG_ZIADOST] = true;
          return updated;
        });
      }

      //Remove KOD_ZIADOSTI parameter from url
      urlParams.delete(parameterNameKodZiadostiInUrl);
      urlParams.size > 0
        ? navigate(`${location.pathname}?${urlParams.toString()}`)
        : navigate(location.pathname);
    }
  }, [data]);


  // GRID PROPS
  const handleChange = useCallback((filter, sort, page) => {
    setFilter(filter);
    setSort(sort);
    setPage(page);
  }, [])

  const handleOnGetList = useCallback(async () => {
    const { getListZiadosti } = props;
    await getListZiadosti(filter.current, sort.current, page.current);
  }, [props.getListZiadosti]);
  const handleOnGet = useCallback((item) => {
    const ziadost = item?.Data ?? null;
    props.changeZiadost(ziadost);
  }, [props.changeZiadost]);


  const genSchema = () => {
    return [
      {
        field: "KOD_ZIADOSTI",
        title: "Kód",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Kód"
      },
      {
        field: "ADRESA_STAVBA",
        title: "Adresa",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Adresa"
      },
      {
        field: "ZIADATEL",
        title: "Žiadateľ",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Žiadateľ"
      },
      {
        field: "N_STAV_ZIAD",
        title: "Stav",
        width: "140px",
        filterable: true,
        filter: "text",
        filterTitle: "Stav"
      },
      {
        field: "D_POD",
        title: "Vytvorené",
        width: "auto",
        format: "{0:dd.MM.yyyy}",
        filterable: true,
        filter: "datetimeinput",
        operator: "datetimeinput",
        type: "datetimeinput",
        filterTitle: "Vytvorené"
      },
      {
        field: "N_UZ_VYBAVUJE",
        title: "Vybavuje",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Vybavuje"
      },
      {
        field: "Priorita.SKR",
        title: "Priorita",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Priorita"
      },
      {
        field: "D_VYBAVENIA",
        title: "Vybavené",
        width: "auto",
        format: "{0:dd.MM.yyyy}",
        filterable: true,
        filter: "datetimeinput",
        operator: "datetimeinput",
        type: "datetimeinput",
        filterTitle: "Vybavené"
      },
    ];
  };
  const schema = useMemo(() => genSchema(), []);

  const fixedFilter = useMemo(() => ({ filters: [] }), []);
  const noop = useCallback(() => { }, []);
  const emptyArray = useMemo(() => [], []);

  useDidMount(async () => {
    const {
      showAppHeader,
      changeHeaderTitle,
      listDovod,
      listPriorita,
      listStavZiadosti,
      listTypPrace,
      getListZP_C_DOVOD,
      getListZP_C_PRIORITA,
      getListZP_C_STAV_ZIADOSTI,
      getListZP_C_TYP_PRACE,
    } = props;

    showAppHeader(false);
    changeHeaderTitle("Moje žiadosti");
    // get ciselniky data
    if (listDovod.length === 0) getListZP_C_DOVOD();
    if (listPriorita.length === 0) getListZP_C_PRIORITA();
    if (listStavZiadosti.length === 0) getListZP_C_STAV_ZIADOSTI();
    if (listTypPrace.length === 0) getListZP_C_TYP_PRACE();
  });


  const cellRender = useCallback((tdElement, cellProps) => {
    const { field, dataItem } = cellProps;
    var tdProps = { ...tdElement.props };
    var children = tdElement.props.children;

    if (field === "N_STAV_ZIAD") {
      tdProps.className += " stav";
      const className = (dataItem["N_STAV_ZIAD"] === "Uzavreté" ? " green" :
        (dataItem["N_STAV_ZIAD"] === "Zamietnuté" ? " red" :
          (dataItem["N_STAV_ZIAD"] === "Rezervované" ? " orange" : " yellow")));
      const iconClassName = (dataItem["N_STAV_ZIAD"] === "Uzavreté" ? "k-icon k-font-icon k-i-check" :
        (dataItem["N_STAV_ZIAD"] === "Zamietnuté" ? "k-icon k-font-icon k-i-close" :
          (dataItem["N_STAV_ZIAD"] === "Rezervované" ? "k-icon k-font-icon k-i-lock" : "k-icon k-font-icon k-i-folder-open")));
      children = (<div className={className}><span>{children}</span><span className={iconClassName}></span></div>);
    }

    return React.cloneElement(tdElement, { ...tdProps }, children);
  }, []);

  const handleGridSelect = useCallback((selected) => {
    setSelected(selected);
  }, []);


  const isDesktop = useMemo(() => {
    return window.matchMedia('only screen and (min-width: 768px)').matches
  }, []);
  const user = storage.getUser();

  return (
    <div className="row m-0">
      <div className="col p-0">
        <div className="grid-info-row"><div className="grid-info-row-name">Moje žiadosti</div><div className="grid-info-row-filters"></div></div>
        <Tabs>
          <Tab title="Zoznam">
            <Grid
              className={(isDesktop ? "" : " mobile") + " ziadosti"}
              total={total}
              data={data}
              isLoading={isLoading}
              onChange={handleChange}
              onGet={handleOnGet}
              onGetList={handleOnGetList}
              onExpandChange={expandChange}
              selected={selected}
              onSelect={handleGridSelect}
              primaryField="copy1-I_AG_ZIADOST"
              detailExpand={detailExpand}
              schema={schema}
              detailSchema={emptyArray}
              detail={ZiadostDetail}
              cellRender={cellRender}
              allColumns
              multiple
              printable
              cellSelect
              fixedFilter={fixedFilter}
              onChangeField={noop}
              onDelete={noop}
              onCancel={noop}
              updateSort={noop}
              initSort={initSort}
              filter={filter.current}
              sort={sort.current}
              page={page.current}
              hidden={flags.ADD | flags.COPY | flags.DELETE | flags.CANCEL | flags.PRINT | flags.RESET |
                flags.EDIT | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.EDITALL | flags.GRID_CELL_EDIT | flags.USER_FILTER | flags.DETAIL}
              hiddenBack
              userFilterList={emptyArray}
              userFilterExtended={emptyArray}
              showMsg={props.showMsg}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    // list ziadosti
    isLoading: state.myListZiadost.isLoading,
    listZiadosti: state.myListZiadost.data,
    total: state.myListZiadost.total,

    // ciselniky
    listDovod: state.zpCDovod.list,
    listPriorita: state.zpCPriorita.list,
    listStavZiadosti: state.zpCStavZiadosti.list,
    listTypPrace: state.zpCTypPrace.list,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getListZP_C_DOVOD: async () =>
    await dispatch(zpCDovodActions.getZP_C_DOVOD()),
  getListZP_C_PRIORITA: async () =>
    await dispatch(zpCPrioritaActions.getZP_C_PRIORITA()),
  getListZP_C_STAV_ZIADOSTI: async () =>
    await dispatch(zpCStavZiadostiActions.getZP_C_STAV_ZIADOSTI()),
  getListZP_C_TYP_PRACE: async () =>
    await dispatch(zpCTypPraceActions.getZP_C_TYP_PRACE()),
  getListZiadosti: (filter, sort, page) =>
    dispatch(ziadostActions.getMyListZiadost(filter, sort, page)),
  changeZiadost: (ziadost) => dispatch(ziadostActions.changeZiadost(ziadost)),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

MojeZiadosti.propTypes = {
  changeHeaderTitle: PropTypes.func,
  changeZiadost: PropTypes.func,
  getListZP_C_DOVOD: PropTypes.func,
  getListZP_C_PRIORITA: PropTypes.func,
  getListZP_C_STAV_ZIADOSTI: PropTypes.func,
  getListZP_C_TYP_PRACE: PropTypes.func,
  getListZiadosti: PropTypes.func,
  isLoading: PropTypes.bool,
  listZiadosti: PropTypes.arrayOf(ziadostPropTypes.ziadost),
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(MojeZiadosti);
